import { Component, OnDestroy, OnInit } from '@angular/core';
import { GlobalInfoService, AuthenticationService } from '@app/core';
import { ManagementSystemDataService } from './shared/management-system-data.service';
import { SedeEmpresa, Const } from '@app/shared';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';

export type Action = 'add' | 'update' | 'delete';

@Component({
  selector: 'iw-management-system',
  templateUrl: './management-system.component.html',
  styleUrls: ['./management-system.component.scss'],
  providers: [ManagementSystemDataService]
})
export class ManagementSystemComponent implements OnInit, OnDestroy {
  // Contiene el id de la empresa del usuario logueado
  empresaSelect: number;
  // Variables para determinar la carga de datos y mostrar un mensaje
  loadingFinishSedes = false;
  // Activa la pestaña de info empresa
  activateAccessTabCompany = false;
  // Activa la pestaña de sedes
  activateAccessTabSedes = false;
  // Define los tipos de permisos que tiene el usuario en sesión
  activateAction = {
    reviewSede: false,
  };
  // Contenedor de las sedes
  sedes: SedeEmpresa[] = [];
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();

  constructor(
    private msds: ManagementSystemDataService,
    private gis: GlobalInfoService,
    private as: AuthenticationService,
    private toastr: ToastrService
    ) { }

  ngOnInit() {

    // Modificando el titulo del modulo
    this.gis.set({ title: 'Administración general del sistema' });

    // Se validan los permisos para los tab para la administracion general de sistema
    // Tab Gestión empresa
    if (
      this.as.confirmPermission(
        Const.types_permissions.administrationSystem ,
        Const.types_action_permissions.updateCompany)
    ) {
      this.activateAccessTabCompany = true;
    }

    // Tab Gestión sedes
    if (
      this.as.confirmPermission(
        Const.types_permissions.administrationSystem ,
        Const.types_action_permissions.reviewSede) ||
      this.as.confirmPermission(
        Const.types_permissions.administrationSystem ,
        Const.types_action_permissions.createSede) ||
      this.as.confirmPermission(
        Const.types_permissions.administrationSystem ,
        Const.types_action_permissions.updateSede) ||
      this.as.confirmPermission(
        Const.types_permissions.administrationSystem ,
        Const.types_action_permissions.deleteSede)
    ) {
      this.activateAccessTabSedes = true;
    }

    // Permiso de ver del usuario en sesion
    // Sedes
    this.activateAction.reviewSede = this.as.confirmPermission(
      Const.types_permissions.administrationSystem,
      Const.types_action_permissions.reviewSede
    );

    this.idSelectCompany();
    // Validando si tiene permiso de ver las sedes
    if (this.activateAction.reviewSede) {
      this.getSedes();
    }
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Obtener id empresa según usuario logueado
   *
   * @memberof ManagementSystemComponent
   */
  idSelectCompany() {
    this.empresaSelect = this.msds.idSelectCompany();
  }

  /**
   * Obtener las sedes de la empresa
   *
   * @memberof ManagementSystemComponent
   */
  getSedes() {
    this.msds.getSedes(this.empresaSelect).subscribe(sedes => {
      this.sedes = sedes;
      this.loadingFinishSedes = true;
    });
  }

  /**
   * Refrescar los datos de la dependencias si se elimina una sede
   *
   * @param {string} data
   * @param {Action} action
   * @memberof ManagementSystemComponent
   */
  refreshData(data: string, action?: Action) {
    if (data === 'sedes') {
      this.getSedes();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/management-system/management-system.component.ts